"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locales = void 0;
exports.locales = [
    'cy_GB',
    'da_DK',
    'de_DE',
    'de_AT',
    'de_CH',
    'en_US',
    'en_CA',
    'en_AU',
    'en_NZ',
    'en_GB',
    'en_IE',
    'en_PH',
    'en_SG',
    'en_ZA',
    'es_ES',
    'es_CL',
    'es_MX',
    'es_PR',
    'es_PA',
    'fr_FR',
    'fr_BE',
    'fr_CH',
    'fr_CA',
    'id_ID',
    'it_IT',
    'it_CH',
    'ja_JP',
    'ms_MY',
    'nl_BE',
    'nl_NL',
    'no_NO',
    'pt_PT',
    'pt_BR',
    'sv_SE',
    'si_LK',
    'th_TH',
    'zh_CN',
    'zh_SG',
    'zh_TW',
    'zh_HK',
];
exports.default = exports.locales;
